import React, { useState } from "react";
import { Navigate, Route, Routes } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Login from "../auth/login/login";
import { useAuth } from "../../core/context/useAuthContext";

const ALLRoutes: React.FC = () => {
  const { isAuthenticated } = useAuth();
  // const isAuthenticated = true;

  return (
    <>
      <Routes>
        {isAuthenticated ? (
          <Route element={<Feature />}>
            {publicRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={idx} />
            ))}
          </Route>
        ) : (
          <>
            <Route path="/login" element={<Login />} />
            {publicRoutes.map((route, idx) => (
              <Route
                key={idx}
                path={route.path}
                element={<Navigate to="/login" />}
              />
            ))}
          </>
        )}

        <Route element={<AuthFeature />}>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
      </Routes>
    </>
  );
};

export default ALLRoutes;
